import potholes from '@highways/assets/potholes.png';
import manhole from '@highways/assets/manhole.png';
import brickRoads from '@highways/assets/brickroads.png';
import roadMarkings from '@highways/assets/roadmarkings.png';
import potholesPavement from '@highways/assets/potholes_pavement.png';
import unevenSurfacesPavement from '@highways/assets/uneven_surfaces_pavement.png';
import pavingSlabs from '@highways/assets/pavingslabs.png';
import coversPavement from '@highways/assets/covers_pavement.png';

export enum HighwaysDamageType {
  Potholes = 'Potholes',
  UnevenSurfaces = 'Uneven surfaces',
  ManholeCovers = 'Manhole covers',
  BrickRoads = 'Brick roads',
  RoadMarkings = 'Road markings',
  PavingSlabs = 'Paving slabs or stones',
  Covers = 'Covers',
}

export const ROAD_DAMAGE_TYPES = [
  {
    title: HighwaysDamageType.Potholes,
    description: 'Dips or holes in the road',
    image: potholes,
  },
  {
    title: HighwaysDamageType.UnevenSurfaces,
    description: 'Cracked, loose or worn road surfaces',
    image: unevenSurfacesPavement,
  },
  {
    title: HighwaysDamageType.ManholeCovers,
    description: 'Loose, noisy or worn covers',
    image: manhole,
  },
  {
    title: HighwaysDamageType.BrickRoads,
    description: 'Broken, loose or missing bricks',
    image: brickRoads,
  },
  {
    title: HighwaysDamageType.RoadMarkings,
    description: 'Faded or missing lines on the road',
    image: roadMarkings,
  },
];

export const PAVEMENT_DAMAGE_TYPES = [
  {
    title: HighwaysDamageType.Potholes,
    description: 'Dips or holes in the pavement',
    image: potholesPavement,
  },
  {
    title: HighwaysDamageType.UnevenSurfaces,
    description: 'Cracked, raised or sunken pavement',
    image: unevenSurfacesPavement,
  },
  {
    title: HighwaysDamageType.PavingSlabs,
    description: 'Loose, missing slabs or stones',
    image: pavingSlabs,
  },
  {
    title: HighwaysDamageType.Covers,
    description: 'Broken, loose or worn covers',
    image: coversPavement,
  },
];
